import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import { parseURL } from "../../common/formatedUrl"
import humantime from 'flarum/common/helpers/humanTime';
export default class MoneyRecordItem extends Component {

  oninit(vnode) {
    super.oninit(vnode);
  }

  oncreate(vnode) {
    super.oncreate(vnode);
  }

  onupdate(vnode) {
    super.onupdate(vnode);
  }

  view() {
    const recordAttr = this.attrs.record.attributes;
    const type = recordAttr.remove_time ? 'reversed' : recordAttr.money > 0 ? 'add' : 'reduce';
    const moneyName = app.forum.attribute('antoinefr-money.moneyname') || '[money]';
    let data = recordAttr.data.split("<>");
    data['actor_id'] = recordAttr.actor_id;
    data['target_id'] = recordAttr.target_id;
    data['user_id'] = recordAttr.user_id;

    const descAttr = type == "reversed" ? "reversed" : "desc";
    return (
      <div className={type != "reversed" ? "money-record-item" : "money-record-item money-record-item-removed"}>
        <b class="money-record-item-name">
          {app.translator.trans(`${recordAttr.reason}.name`)}
        </b>
        <small class="money-record-item-desc">
          {app.translator.trans(`${recordAttr.reason}.${descAttr}`)}
        </small>
        <div class="money-record-item-amount">
          {
            type != "reversed" ?
              ((type == "add" ? "+" : "-") + moneyName.replace('[money]', Math.abs(recordAttr.money) - Math.abs(parseFloat(recordAttr.tax || 0))))
              :
              app.translator.trans(`xypp-money-more.forum.page.money.${type}`)
          }
          <small>
            {recordAttr.tax ? app.translator.trans(`xypp-money-more.forum.page.tax`, [recordAttr.tax]) : ''}
          </small>
        </div>
        <div class="money-record-item-data">
          <div>
            {parseURL(app.translator.trans(`${recordAttr.reason}.item`, data))}</div>
        </div>
        <div class="money-record-item-time">
          {type != "reversed"
            ? app.translator.trans('xypp-money-more.forum.page.create-time', { time: humantime(recordAttr.create_time) }) :
            app.translator.trans('xypp-money-more.forum.page.removed-time', { time: humantime(recordAttr.remove_time) })}
        </div>
      </div>
    );
  }
}
